import React from 'react';
import PropTypes from 'prop-types';
import {

  ThemeProvider,
  crTheme
} from '@comicrelief/component-library';
import { snakeCase } from 'lodash';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

import 'lazysizes';

import '@comicrelief/component-library/dist/style.css';

import {
  Wrapper, SkipNav, Main, HeaderWrapper, ContentArea, FooterWrapper
} from './Layout.styles';

const Layout = ({
  children,
  removeDonateLink = false,
  theme = 'comicrelief',
  landingPageCartId = null,
  backgroundColour = ''
}) => {
  const thisBgColour = snakeCase(backgroundColour || 'grey_light');

  return (
    <ThemeProvider theme={crTheme}>
      <SkipNav href="#main-content">
        Skip to main content
      </SkipNav>
      <Wrapper backgroundColour={thisBgColour}>
        <HeaderWrapper data-testid="HeaderWrapper">
          <Header
            data-testid="Header"
            removeDonateLink={removeDonateLink}
            campaign={theme}
            landingPageCartId={landingPageCartId}
          />
        </HeaderWrapper>
        <ContentArea>
          <Main role="main" id="main-content">
            {children}
          </Main>
          <FooterWrapper>
            <Footer />
          </FooterWrapper>
        </ContentArea>
      </Wrapper>
    </ThemeProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  removeDonateLink: PropTypes.bool,
  theme: PropTypes.string,
  landingPageCartId: PropTypes.string,
  backgroundColour: PropTypes.string
};

export default Layout;
